import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { LanguageSelectorComponent, MediaObserverService } from '@imagise/shared';
import { HEADER_MENU } from './header-menu';
import { HeaderDesktopNavComponent } from './header-desktop-nav.component';
import { HeaderMobileNavComponent } from './header-mobile-nav.component';

@Component({
  selector: 'lib-header',
  imports: [
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    LanguageSelectorComponent,
    HeaderDesktopNavComponent,
    HeaderMobileNavComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private mediaObserver = inject(MediaObserverService);

  protected readonly menu = HEADER_MENU;

  readonly isMenuOpen = signal(false);

  constructor() {
    // Close the mobile menu once the viewport reaches the desktop breakpoint.
    this.mediaObserver.breakpoint$.pipe(takeUntilDestroyed()).subscribe(breakpoint => {
      if (this.isMenuOpen() && this.mediaObserver.isBreakpointUp(breakpoint, 'lg')) {
        this.isMenuOpen.set(false);
      }
    });
  }

  toggleMobileMenu() {
    this.isMenuOpen.update(open => !open);
  }

  closeMobileMenu() {
    this.isMenuOpen.set(false);
  }
}
